<template>
    <div class="maincontainer analyses" v-observe-visibility="visibilityChange">
        <div class="row">
            <div class="col s8">
                <h4>{{$t('routine_analyses.title')}}</h4>
            </div>
            <div class="col s4 hiddenprint" style="margin-top: 22.8px;">
                <button class="btn green adder" v-on:click="print()">
                    <i class="material-icons left">print</i>{{$t('menu.buttons.print')}}
                </button>
                <a :href="'/customers/'+customer_id+'/places/'+place_id+'/devices/analyses/'+(orderby == 'zone_id' ? 1 : 0)+'/'+this.$options.filters.formattimestamp(from)+'/'+this.$options.filters.formattimestamp(to)+'.xlsx'" class="btn waves-effect waves-light btn-large emptygreen">
                    XLS
                </a>
            </div>
        </div>
        <button class="waves-effect waves-light btn-large hiddenprint" :class="[mode == 'categories' ? 'red' : 'grey', '']" v-on:click="mode = 'categories'">{{$t('routine_analyses.categories')}}</button>
        <button class="waves-effect waves-light btn-large hiddenprint" :class="[mode == 'targetpests' ? 'red' : 'grey', '']" v-on:click="mode = 'targetpests'">{{$t('routine_analyses.target_pests')}}</button>
        <button class="waves-effect waves-light btn-large hiddenprint" :class="[mode == 'devices' ? 'red' : 'grey', '']" v-on:click="mode = 'devices'">{{$t('routine_analyses.devices')}}</button>
        <div style="font-size: large; padding-top: 15px; padding-bottom: 15px">{{$t('routine_analyses.object')}}: {{place.name}}</div>
        <div style="font-size: large;">
            <h5 style="padding: 0; margin: 0;">{{$t('routine_analyses.timeframe')}}:</h5>
        </div>
        <div class="row">
            <div class="col col-s6" style="font-size: large; margin-top: 5px; margin-bottom: 5px; padding: 5px; border: 1px solid black;"><i class="material-icons">event</i>{{from | formatDateLong}} - {{to | formatDateLong}}</div>
        </div>
        <div class="row">
            <div style="padding: 0" class="col col-s3">
                <select id="place_analyses_selectedinterval" v-model="selectedinterval">
                    <option value="lastthreemonths">{{$t('routine_analyses.last_three_months')}}</option>
                    <option value="lastsixmonths">{{$t('routine_analyses.last_six_months')}}</option>
                    <option value="lastyear">{{$t('routine_analyses.last_year')}}</option>
                    <option value="prevyear">{{$t('routine_analyses.past_year')}}</option>
                    <option value="other">{{$t('routine_analyses.other_scope')}}</option>
                </select>
            </div>
            <div class="col col-s3" v-if="selectedinterval == 'other'">
                <input type="date" id="meeting-time" name="meeting-time" v-model="from" style="height: 32px;" />
            </div>
            <div class="col col-s3" v-if="selectedinterval == 'other'">
                <input type="date" id="meeting-time" name="meeting-time" v-model="to" style="height: 32px;" />
            </div>
        </div>
        <template v-if="mode == 'categories'">
            
             <div class="hiddenprint">
                <collapsible title="Filtruj">
             <ul>
                <template v-for="zone in  listZones">
                <li v-on:click="toggleZone(zone)">
                    &nbsp;{{nameGroup(zone)}}
                </li>
                <template v-for="row in listItems" v-if="row.group == zone">
                <li v-on:click="toggleGroupSubgroup(row.group, row.subgroup)"  :class="{ filteractive:openedZones.indexOf(''+row.group+':'+row.subgroup) == -1, filterinactive:openedZones.indexOf(''+row.group+':'+row.subgroup) > -1}">
                    {{nameSubgroup(row.subgroup)}}
                </li>
                </template>
                </template>
            </ul>
            </collapsible>
        </div>
            <div v-if="loaded_inspections == false || loaded == false" style="text-align: center;">
                    <div class="preloader-wrapper big active">
                        <div class="spinner-layer spinner-red-only">
                            <div class="circle-clipper left">
                                <div class="circle"></div>
                            </div>
                            <div class="gap-patch">
                                <div class="circle"></div>
                            </div>
                            <div class="circle-clipper right">
                                <div class="circle"></div>
                            </div>
                        </div>
                    </div>
            </div>

            <template v-if="visible">
                
                <div v-if="loaded_inspections && loaded && inspections.length > 0">
                    <template v-if="loaded_inspections && loaded && openedZones.length == 0">
                        <h6 class="section" style="color: black; padding-left: 15px;margin-top: 1rem;">{{$t('routine_analyses.inspections')}}</h6>
                        {{$t('routine_analyses.average_pests_activity')}}: {{from | formatDateMonth}} - {{to | formatDateMonth}}
                        <line-chart :inspections="inspections" :devcats="devcats" v-if="loaded"></line-chart>
                    </template>
                    <div class="row" style="margin-top: 30px;">
                        <div class="col m5">
                            <h5 style="margin-top: 0px; margin-bottom: 0px;">{{$t('routine_analyses.title')}}</h5>
                        </div>
                        <div class="col m3 rightlabel hiddenprint" style="padding-top: 15px; padding-bottom: 15px;"><span>{{$t('routine_analyses.order_by')}}:</span></div>
                       <div class="col m4" style="padding-top: 15px; padding-bottom: 15px;">
                            <select id="place_analyses_groupby" v-model="groupby">
                                <option value="dev_category">{{$t('routine_analyses.by_categories')}}</option>
                                <option value="zone_id">{{$t('routine_analyses.by_zones')}}</option>
                            </select>
                        </div>

                    </div>
                    <div v-if="loaded_inspections && loaded && inspections.length > 0" class="row" v-for="row in listItems" :key="row.group+':'+row.subgroup">
                        <!-- <h4>{{nameSubgroup(subgroup)}}</h4> -->
                        <template v-if="groupby == 'dev_category'">
                            <h6 class="section" style="color: black; padding-left: 5px; padding-top: 5px; padding-bottom: 5px; margin-top: 1rem;" v-on:click="toggleGroup(row.group)">
                                {{nameGroup(row.group)}}
                            </h6>
                            <template v-if="openedZones.indexOf(row.group) == -1">
                                <table>
                                    <tr>
                                        <th>{{$t('customers.number')}}</th>
                                        <th v-for="inspection in inspections">{{inspection.date | formatDate}}</th>
                                        <th>{{$t('routine_analyses.average')}}</th>
                                        <th>{{$t('routine_analyses.deviation')}}</th>
                                        <th>{{$t('routine_analyses.reported_pests')}}</th>
                                    </tr>
                                    <tr>
                                        <td>{{$t('routine_analyses.maximum')}}</td>
                                        <td v-for="inspection in inspections" :style="{'background-color':  colorForCell(maxForInspection(inspection, categories_groups_devices[row.group]))}" :title="$t('devices.routine_analyses.maximum')">{{maxForInspection(inspection, categories_groups_devices[row.group])}}</td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td>{{$t('routine_analyses.minimum')}}</td>
                                        <td v-for="inspection in inspections" :style="{'background-color':  colorForCell(minForInspection(inspection, categories_groups_devices[row.group]))}" :title="$t('devices.routine_analyses.minimum')">{{minForInspection(inspection, categories_groups_devices[row.group])}}</td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td>{{$t('routine_analyses.average')}}</td>
                                        <td v-for="inspection in inspections" :style="{'background-color':  colorForCell(averageForInspection(inspection, categories_groups_devices[row.group]))}" :title="$t('devices.routine_analyses.average')">{{averageForInspection(inspection, categories_groups_devices[row.group])}}</td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td>{{$t('routine_analyses.median')}}</td>
                                        <td v-for="inspection in inspections" :style="{'background-color':  colorForCell(medianForInspection(inspection, categories_groups_devices[row.group]))}" :title="$t('devices.routine_analyses.median')">{{medianForInspection(inspection, categories_groups_devices[row.group])}}</td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td style="vertical-align: top;">{{$t('routine_analyses.reported_pests')}}</td>
                                        <td v-for="inspection in inspections" class="rotate">
                                            <div :style="{width: ((20 * pestsForInspection(inspection, categories_groups_devices[row.group]).length+1)) + 'px', 'line-height': 1}">
                                                <span v-for="(pest, index) in pestsForInspection(inspection, categories_groups_devices[row.group])">
                                                    {{pest}}
                                                    <template v-if="(index) < pestsForInspection(inspection, categories_groups_devices[row.group]).length-1">,
                                                    </template>
                                                </span>
                                            </div>
                                        </td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                </table>
                                <div class="row">
                                    <div class="col s6">
                                        <div>
                                            <h6>{{$t('routine_analyses.average_inspections')}}</h6>
                                            <col-chart-inspections :devices="categories_groups_devices[row.group]" :inspections="inspections" :properties="properties" :color="groupColor(row.group)" />
                                        </div>
                                    </div>
                                    <div class="col s6">
                                        <div>
                                            <h6>{{$t('routine_analyses.percentages')}}</h6>
                                            <percent-chart :devices="categories_groups_devices[row.group]" :inspections="properties" :properties="properties" :color="groupColor(row.group)" />
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col s6">
                                        <avggraph :devices="categories_groups_devices[row.group]"  :group="row.group" :subgroup="row.subgroup" :inspections="properties" :color="groupColor(row.group)" />
                                        }
                                    </div>
                                    <div class="col s6">
                                        <stddgraph :devices="categories_groups_devices[row.group]"  :group="row.group" :subgroup="row.subgroup" :inspections="properties" :color="groupColor(row.group)" />
                                    
                                    </div>
                                </div>
                                <div>
                                    <h6>{{$t('routine_analyses.critical_exceeds')}}:</h6>
                                </div>
                                <div style="margin-bottom: 3em;">
                                    <h6>{{$t('routine_analyses.exceeds_thresholds')}}</h6>
                                </div>
                            </template>
                        </template>
                        <template v-if="loaded_inspections && loaded && groupby == 'zone_id'">
                             
                             <template v-if='openedZones.indexOf(""+row.group+":"+row.subgroup) == -1'>
                                <h6 style="color: black; padding-left: 5px; padding-top: 5px; padding-bottom: 5px; margin-top: 1rem;" class="section">
                                    <b>{{$t('routine_analyses.category')}}: {{nameSubgroup(row.subgroup)}}</b>
                                    <br />
                                    {{$t('routine_analyses.zone')}}: {{nameGroup(row.group)}}
                                 </h6>
                                <table>
                                    <tr>
                                        <th>{{$t('customers.number')}}</th>
                                        <th v-for="inspection in inspections">{{inspection.date | formatDate}}</th>
                                        <th>{{$t('routine_analyses.average')}}</th>
                                        <th>{{$t('routine_analyses.deviation')}}</th>
                                        <th>{{$t('routine_analyses.reported_pests')}}</th>
                                    </tr>
                                     <tr v-for="device in row.items">
                                        <td>{{device.number}}</td>
                                        <td v-for="inspection in inspections" :title="inspectionDeviceConditions(inspection, device) == 0 ? 'brak aktywności' :pestsForInspection(inspection, [device]).join(', ')">{{inspectionDeviceConditions(inspection, device)}}</td>
                                        <td :title="$t('devices.routine_analyses.average_device')">{{averageForDevice(device.id)}}</td>
                                        <td :title="$t('devices.routine_analyses.stddev_device')">{{stddevForDevice(device.id)}}</td>
                                        <td>{{pestsForDevice(device.id)}}</td>
                                    </tr>
                                    <tr>
                                        <td>{{$t('routine_analyses.maximum')}}</td>
                                        <td v-for="inspection in inspections" :style="{'background-color':  colorForCell(maxForInspection(inspection, zones_groups_devices[row.group][row.subgroup]))}" :title="$t('devices.routine_analyses.maximum')">{{maxForInspection(inspection, zones_groups_devices[row.group][row.subgroup])}}</td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td>{{$t('routine_analyses.minimum')}}</td>
                                        <td v-for="inspection in inspections" :style="{'background-color':  colorForCell(minForInspection(inspection, zones_groups_devices[row.group][row.subgroup]))}" :title="$t('devices.routine_analyses.minimum')">{{minForInspection(inspection, zones_groups_devices[row.group][row.subgroup])}}</td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td>{{$t('routine_analyses.average')}}</td>
                                        <td v-for="inspection in inspections" :style="{'background-color':  colorForCell(averageForInspection(inspection, zones_groups_devices[row.group][row.subgroup]))}" :title="$t('devices.routine_analyses.average')">{{averageForInspection(inspection, zones_groups_devices[row.group][row.subgroup])}}</td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        </r>
                                    <tr>
                                        <td>{{$t('routine_analyses.median')}}</td>
                                        <td v-for="inspection in inspections" :style="{'background-color':  colorForCell(medianForInspection(inspection, zones_groups_devices[row.group][row.subgroup]))}" :title="$t('devices.routine_analyses.median')">{{medianForInspection(inspection, zones_groups_devices[row.group][row.subgroup])}}</td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td style="vertical-align: top;">{{$t('routine_analyses.reported_pests')}}</td>
                                        <td v-for="inspection in inspections" class="rotate">
                                            <div :style="{width: (20 * pestsForInspection(inspection, zones_groups_devices[row.group][row.subgroup]).length+1) + 'px', 'line-height': 1}">
                                                <span v-for="(pest, index) in pestsForInspection(inspection, zones_groups_devices[row.group][row.subgroup])">
                                                    {{pest}}
                                                </span>
                                            </div>
                                        </td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                </table>
                                <div class="row">
                                    <div class="col s6">
                                        <div>
                                            <h5>{{$t('routine_analyses.average_inspections')}}</h5>
                                            <col-chart-inspections :devices="zones_groups_devices[row.group][row.subgroup]" :inspections="inspections" :properties="properties" :color="groupColor(row.group)" />
                                        </div>
                                    </div>
                                    <div class="col s6">
                                        <div>
                                            <h5>{{$t('routine_analyses.percentages')}}</h5>
                                            <percent-chart :devices="zones_groups_devices[row.group][row.subgroup]" :inspections="properties" :properties="properties" :color="groupColor(row.group)" />
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col s6">
                                        <avggraph :devices="row.items" :group="row.group" :subgroup="row.subgroup" :inspections="properties" :color="groupColor(row.group)" />
                                    </div>
                                    <div class="col s6">
                                        <stddgraph :devices="row.items" :group="row.group" :subgroup="row.subgroup" :inspections="properties" :color="groupColor(row.group)" />
                                    </div>
                                </div>
                                <div>
                                    <h6>{{$t('routine_analyses.critical_exceeds')}}:</h6>
                                </div>
                                <div style="margin-bottom: 3em;">
                                    <h6>{{$t('routine_analyses.exceeds_thresholds')}}</h6>
                                </div>
                                <div>
                                    <template v-for="(crit, index) in criteriaForDeviceZone(row.group, row.subgroup)">
                                        <template v-if="index == 0">
                                            {{crit[1].created_at | formatDateLong}}
                                        </template>
                                        <template v-else>
                                            {{crit[1].updated_at | formatDateLong}}
                                        </template>
                                        -
                                        <template v-if="index < (criteriaForDeviceZone(row.group, row.subgroup).length-1)">
                                            {{criteriaForDeviceZone(row.group, row.subgroup)[index + 1][1].updated_at | formatDateLong}}
                                        </template>
                                        <template v-else>
                                            ...
                                        </template>
                                        <criterium :criterium=crit[1] :from_zone="nameGroup(row.group) != null" :pests="pests" :has_disaster_point="false"></criterium>
                                    </template>
                                </div>
                            </template>
                        </template>
                    </div>
                </div>
                <p style="font-size: 12px;" v-if="loaded_inspections && loaded && inspections.length == 0">
                    {{$t('devices.routine_analyses.no_data')}}
                </p>
            </template>
        </template>
        <template v-if="mode == 'targetpests'">
            <div v-if="loaded_inspections == false || loaded == false" style="text-align: center;">
                <div class="preloader-wrapper big active">
                    <div class="spinner-layer spinner-red-only">
                        <div class="circle-clipper left">
                            <div class="circle"></div>
                        </div>
                        <div class="gap-patch">
                            <div class="circle"></div>
                        </div>
                        <div class="circle-clipper right">
                            <div class="circle"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="loaded_inspections && loaded" v-for="(pestitems, group) in targetpests">
                <h5 style="border:  black solid 2px;padding-left: 15px;"> {{pestsgroups[group].group_name}} - {{$t('devices.routine_analyses.pests_quantities')}}: {{from | formatDateLong}} - {{to | formatDateLong}}</h5>
                <pests-chart :properties="groupbyinspections(pestitems, group)" :inspections="inspections" :pests="pests" />
                <template v-if="pestitems.length == 0">{{$t('devices.routine_analyses.no_data')}}</template>
                <template v-for="(props, pest) in pestitems">
                    <div class="row" style="border:  black solid 2px;padding-left: 15px;" v-if="groupHasQuantity(group, pest, listItems)">
                        <div class="col m6" style="padding-top: 15px; padding-bottom: 15px;">
                            <h5 style="padding: 0px; margin: 0px;"> {{pests[pest].name}} —  {{$t('devices.routine_analyses.period_analysis')}}</h5>
                        </div>
                        <div class="col m4" style="padding-top: 15px; padding-bottom: 15px;">
                            <select id='place_analyses_groupby' v-model="groupby">
                                <option value="dev_category">{{$t('routine_analyses.by_categories')}}</option>
                                <option value="zone_id">{{$t('routine_analyses.by_zones')}}</option>
                            </select>
                        </div>
                    </div>
                    <div v-if="loaded_inspections && loaded" class="row" v-for="(items, subgroup) in listItems">
                        <h4>{{nameSubgroup(subsubgroup)}}</h4>
                        <template v-if="groupby == 'dev_category' && hasQuantity(group, pest , items)">
                            <div class="col s12 section">
                                <h6>{{nameGroup(subgroup)}}</h6>
                            </div>
                            <table style="margin-top: 1em;">
                                <tr>
                                    <th>{{$t('customers.number')}}</th>
                                    <th v-for="inspection in inspections">{{inspection.date | formatDate}}</th>
                                    <th>{{$t('devices.routine_analyses.sum')}}</th>
                                </tr>
                                <tr v-for="device in items">
                                    <td>{{device.number}}</td>
                                    <td v-for="inspection in inspections" :title="inspectionDevicePests(group, pest, inspection, device)">{{inspectionDevicePestsSum(group, pest, inspection, device)}}</td>
                                    <td :title="$t('devices.routine_analyses.sum_label')">{{devicePestsSum(group, pest, device)}}</td>
                                </tr>
                                <tr>
                                    <td>{{$t('devices.routine_analyses.sum')}}</td>
                                    <td v-for="inspection in inspections">{{inspectionPestsSum(group, pest, inspection, items)}}</td>
                                </tr>
                            </table>
                            <div class="row">
                                <div class="col s6">
                                    <sumgraphquantities :group="group" :devices="items" :properties="targetpests[group][pest]" :color="groupColor(group)" :pest_id="pest" />
                                </div>
                                <div class="col s6">
                                    <zonesinspectionsquantities :inspections="inspections" :devices="items" :properties="targetpests[group][pest]" :color="groupColor(group)" :zonename="nameGroup(subgroup)" :pest_id="pest" />
                                </div>
                            </div>
                        </template>
                        <template v-for="(subitems, subsubgroup) in items" v-if="loaded_inspections && loaded && groupby == 'zone_id' && hasQuantity(group, pest , subitems)">
                            <div class="row">
                                <div class="col s12 section">
                                    <h6><b>{{$t('devices.zone')}}: {{nameGroup(subgroup)}}</b><br />{{nameSubgroup(subsubgroup)}}</h6>
                                </div>
                            </div>
                            <table style="margin-top: 1em;">
                                <tr>
                                    <th>{{$t('customers.number')}}</th>
                                    <th v-for="inspection in inspections">{{inspection.date | formatDate}}</th>
                                    <th>{{$t('devices.routine_analyses.sum')}}</th>
                                </tr>
                                <tr v-for="device in subitems">
                                    <td>{{device.number}}</td>
                                    <td v-for="inspection in inspections" :title="inspectionDevicePests(group, pest, inspection, device)">{{inspectionDevicePestsSum(group, pest, inspection, device)}}</td>
                                    <td :title="$t('devices.routine_analyses.sum_label')">{{devicePestsSum(group, pest, device)}}</td>
                                </tr>
                                <tr>
                                    <td>{{$t('devices.routine_analyses.sum')}}</td>
                                    <td v-for="inspection in inspections">{{inspectionPestsSum(group, pest, inspection, subitems)}}</td>
                                </tr>
                            </table>
                            <div class="row">
                                <div class="col s6">
                                    <sumgraphquantities :group="group" :devices="subitems" :properties="targetpests[group][pest]" :color="groupColor(group)" :pest_id="pest" />
                                </div>
                                <div class="col s6">
                                    <zonesinspectionsquantities :inspections="inspections" :devices="subitems" :properties="targetpests[group][pest]" :color="groupColor(group)" :zonename="nameGroup(subgroup)" :pest_id="pest" />
                                </div>
                            </div>
                        </template>
                    </div>
                </template>
            </div>
            <p style="font-size: 12px;" v-if="loaded_inspections && loaded && inspections.length == 0">
                {{$t('devices.routine_analyses.no_data')}}
            </p>
        </template>
        <template v-if="mode == 'devices'">
            <div class="row" v-if="loaded_inspections && loaded && inspections.length > 0">
                <div class="col m5" style="padding-left: 0;">
                    <span style="margin-top: 0px; margin-bottom: 0px;">{{$t('place.devices')}}:</span>
                </div>
                <div class="col m4" style="padding-top: 15px; padding-bottom: 15px;">
                    <select id='place_analyses_groupby' v-model="groupby">
                        <option value="dev_category">KATEGORIE PUNKTÓW MONITOROWANIA</option>
                        <option value="zone_id">STREFY</option>
                    </select>
                </div>
            </div>
             <div v-if="loaded_inspections && loaded && inspections.length > 0" class="row" v-for="row in listItems" :key="row.group+':'+row.subgroup">
                <template v-if="groupby == 'zone_id'">
                <h4>{{nameGroup(row.group)}}</h4>
                <h4>{{nameSubgroup(row.subgroup)}}</h4>
                <template v-for="subitem in row.items">
                    <h5>{{subitem.number}}</h5>
                    <devicegraph :properties="properties[subitem.id]" :color="groupColor(row.group)" />
                </template>
                </template>
                <template v-if="groupby == 'dev_category'">
                    <h4>{{nameSubgroup(row.group)}}</h4>
                    <template v-for="item in row.items">
                        <h5>{{item.number}}</h5>
                        <devicegraph :properties="properties[item.id]" :color="groupColor(row.group)" />
                    </template>
                </template>
            </div>
            <p style="font-size: 12px;" v-if="loaded_inspections && loaded && inspections.length == 0">
                {{$t('devices.routine_analyses.no_data')}}
            </p>
        </template>
    </div>
</template>
<script>
import Vue2Filters from 'vue2-filters';
import LineChart from './linechart.vue';
import axios from 'axios';
import Moment from 'moment';
import 'moment/locale/pl'
import { extendMoment } from 'moment-range';

const moment = extendMoment(Moment);
export default {
    data: function() {
        return {
            mode: 'categories',
            order: 'desc',
            places: [],
            pests: {},
            loaded: false,
            loaded_inspections: false,
            datacollection: [],
            groupby: 'zone_id',
            orderby: 'zone_id',
            from: moment().startOf('month').add(-2, 'months').format('YYYY-MM-DD'),
            to: moment().endOf('month').format('YYYY-MM-DD'),
            inspections: [],
            properties: {},
            devcats: {},
            devices: [],
            openedZones: [],
            devs: {},
            visible: false,
            selectedinterval: "lastthreemonths"
        }
    },
    props: { customer_id: [String, Number], place_id: [String, Number], last_date: [String], place: [Object] },
    watch: {
        from: function(newVal, oldVal) {
            if (newVal) {
                this.loaded = false;
                this.fetch_inspections();
                this.loaded = true;
            }
        },
        to: function(newVal, oldVal) {
            if (newVal) {
                this.loaded = false;
                this.fetch_inspections();
                this.loaded = true;
            }
        },
        selectedinterval: function(newVal, oldVal) {
            if (newVal == "lastthreemonths") {
                this.from = moment().subtract(6, 'months').startOf("month").format("YYYY-MM-DD")
                this.to = moment().endOf("month").format("YYYY-MM-DD")
            } else if (newVal == "lastsixmonths") {
                this.from = moment().subtract(6, 'months').startOf("month").format("YYYY-MM-DD")
                this.to = moment().endOf("month").format("YYYY-MM-DD")
            } else if (newVal == "lastyear") {
                this.from = moment().startOf("year").format("YYYY-MM-DD")
                this.to = moment().endOf("year").format("YYYY-MM-DD")
            } else if (newVal == "prevyear") {
                this.from = moment().subtract(1, 'years').startOf("year").format("YYYY-MM-DD")
                this.to = moment().subtract(1, 'years').endOf("year").format("YYYY-MM-DD")
            }
        }
    },
    async mounted(){
         if (this.last_date != null) {
            this.from = moment(this.last_date, 'YYYY-MM-DD').startOf('year').format('YYYY-MM-DD');
            this.to = moment(this.last_date, 'YYYY-MM-DD').endOf('year').format('YYYY-MM-DD');
        }
        await this.fetch_places();
    },
    methods: {
        pestsForDevice(device) {
            return _.sortBy(_.compact(_.uniq(_.flatten(_.map(this.properties[device], 'pests'))))).join(", ");
        },
        toggleGroup(group) {
            if (this.openedZones.indexOf("" + group) == -1) {
                this.openedZones.push("" + group);
            } else {
                this.openedZones.splice(this.openedZones.indexOf("" + group), 1);
            }
        },
        toggleZone(zone){
            var groupsInZone = _.filter(this.listAllGroups, function(group){
                return group.indexOf(""+zone+":") == 0;
            });
            var openedZonesInZone = _.filter(this.openedZones, function(group){
                return group.indexOf(""+zone+":") == 0;
            });
            var groupsToToggle = _.difference(groupsInZone, openedZonesInZone);
            if(groupsToToggle.length == 0){
                groupsToToggle = groupsInZone;
            }
            for (var i = groupsToToggle.length - 1; i >= 0; i--) {
                this.toggleGroup(groupsToToggle[i]);
            }
        },
        toggleGroupSubgroup(group, subgroup) {
            if (this.openedZones.indexOf("" + group + ":" + subgroup) == -1) {
                this.openedZones.push("" + group + ":" + subgroup);
            } else {
                this.openedZones.splice(this.openedZones.indexOf("" + group + ":" + subgroup), 1);
            }
        },
        averageForDevice(device) {
            var values = _.map(this.properties[device], 'conditions');
            var avg = _.sum(values) / values.length;
            return _.round(avg, 2) || ""
        },
        stddevForDevice(device) {
            var values = _.map(this.properties[device], 'conditions');
            var avg = _.sum(values) / values.length;
            var stdev = Math.sqrt(_.sum(_.map(values, (i) => (i - avg) * (i - avg))) / values.length);
            return _.round(stdev, 2) || ""
        },
        print(){
            window.print();
        },
        maxForInspection(inspection, devices) {
            var devids = _.map(devices, 'id');
            var propsfordevs = _.pick(this.properties, devids)
            var values = _.map(_.filter(_.flatten(_.values(propsfordevs)), { 'inspection_id': inspection.id }), 'conditions');
            return _.max(values);
        },
        minForInspection(inspection, devices) {
            var devids = _.map(devices, 'id');
            var propsfordevs = _.pick(this.properties, devids)
            var values = _.map(_.filter(_.flatten(_.values(propsfordevs)), { 'inspection_id': inspection.id }), 'conditions');
            return _.min(values);
        },
        averageForInspection(inspection, devices) {
            var devids = _.map(devices, 'id');
            var propsfordevs = _.pick(this.properties, devids)
            var values = _.map(_.filter(_.flatten(_.values(propsfordevs)), { 'inspection_id': inspection.id }), 'conditions');
            var avg = _.sum(values) / values.length;
            if (isNaN(avg) == false) {
                return _.round(avg, 2) || "";
            }
            return ""
        },
        medianForInspection(inspection, devices) {
            var devids = _.map(devices, 'id');
            var propsfordevs = _.pick(this.properties, devids)
            var values = _.map(_.filter(_.flatten(_.values(propsfordevs)), { 'inspection_id': inspection.id }), 'conditions');
            return median(values) || ""
        },
        pestsForInspection(inspection, devices) {
            var devids = _.map(devices, 'id');
            var propsfordevs = _.pick(this.properties, devids)
            var values = _.compact(_.uniq(_.flatten(_.map(_.filter(_.flatten(_.values(propsfordevs)), { 'inspection_id': inspection.id }), 'pests'))));
            return values;
        },
        colorForCell(value) {
            if ((typeof value === 'string' && value == "") || isNaN(value) || value == undefined) {
                return "#fff";
            }
            if (value >= 0 && value < 1) return "#00E855";
            else if (value >= 1 && value < 2) return "#FAFA3C";
            else if (value >= 2 && value < 3) return "#FAC13C";
            else if (value >= 3 && value <= 4) return "#EA3546";
        },
        nameGroup(id) {
            if (this.groupby == 'dev_category') {
                if (_.isUndefined(this.devcats[id])) return ""
                else return this.devcats[id].name
            } else if (id == "null" || id == 0) {
                return "Brak strefy"
            } else {
                if(this.place.zones_groups == undefined) return "";
                if(_.isUndefined(this.place.zones_groups[id])) return ""
                else return this.place.zones_groups[id].name
            }
        },
        nameSubgroup(id) {
            if (this.groupby == 'zone_id') {
                if (_.isUndefined(this.devcats[id])) return ""
                else return this.devcats[id].name
            }
        },
        inspectionDeviceConditions(inspection, device) {
            var pp = _.find(this.properties[device.id], { 'inspection_id': inspection.id });
            if (pp != undefined) {
                return pp.conditions;
            }
            return "-"
        },
        groupColor(id) {
            if (_.isUndefined(this.devcats[id])) return "#ccc"
            else return this.devcats[id].graph_color
        },
        fetch_places: async function() {
            var response = await axios.get('/pests.json');
            this.pests = _.keyBy(response.data, 'id');
            this.pestsgroups = _(this.pests).values().map(function(pest) { return { group_id: pest.group_id, group_name: pest.group_name } }).keyBy('group_id').value();
            if (this.place_id != 0) {
                this.loaded = false
                var response = await axios.get('/device_categories.json')
                this.devcats = _.keyBy(response.data, 'id');
                var response = await axios.get('/customers/' + this.customer_id + '/places/' + this.place_id + '/devices.json')
                this.devs = _.keyBy(response.data, 'id');
                var categories_groups = _.groupBy(response.data, 'dev_category');
                this.categories_groups_devices = {};
                for (var i = _.keys(categories_groups).length - 1; i >= 0; i--) {
                    this.categories_groups_devices[_.keys(categories_groups)[i]] = _.keyBy(categories_groups[_.keys(categories_groups)[i]], 'id')
                }
                var zones_groups = _.groupBy(response.data, 'zone_id');
                this.zones_groups_devices = {};
                for (var i = _.keys(zones_groups).length - 1; i >= 0; i--) {
                    var key = _.keys(zones_groups)[i];
                    var devcats = _.groupBy(zones_groups[key], 'dev_category');
                    this.zones_groups_devices[_.keys(zones_groups)[i]] = {};
                    for (var j = _.keys(devcats).length - 1; j >= 0; j--) {
                        this.zones_groups_devices[_.keys(zones_groups)[i]][_.keys(devcats)[j]] = _.keyBy(devcats[_.keys(devcats)[j]], 'id')
                    }
                    _.keyBy(zones_groups[_.keys(zones_groups)[i]], 'id')
                }
                this.devices = _.keyBy(response.data, 'id');
                this.fetch_inspections();
                this.loaded = true
            }
        },
        fetch_inspections: async function() {
            this.loaded_inspections = false
            var response = await axios.get('/customers/' + this.customer_id + '/places/' + this.place_id + '/inspections/' + moment(this.from).unix() + '/' + moment(this.to).unix() + '.json')
            this.inspections = response.data
            this.inspections.sort(function(a, b) {
                var va = new Date(a.date);
                var vb = new Date(b.date);
                return va - vb;
            });
            var response = await axios.get('/customers/' + this.customer_id + '/places/' + this.place_id + '/devices/properties/' + moment(this.from).unix() + '/' + moment(this.to).unix() + '.json')
            this.properties = _.groupBy(response.data, 'device_id');
            this.$parent.properties = this.properties;
            this.loaded_inspections = true

        },
        collapse: function(customer) {
            customer.collapsed = !(customer.collapsed);
            this.$forceUpdate();
        },
        set_order: function(order) {
            if (this.orderby == order) {
                if (this.order == 'desc') {
                    this.order = 'asc'
                } else if (this.order == 'asc') {
                    this.order = 'desc'
                }

            } else {
                this.orderby = order;
            }
        },
        visibilityChange(evt, hidden) {
            this.visible = evt;
        },
        groupbyinspections(props, gid) {
            var out = {}
            var groups = _.groupBy(_.flatten(_.values(props)), 'date');
            var that = this;
            for (var i = _.keys(groups).length - 1; i >= 0; i--) {
                var group = _.keys(groups)[i];
                for (var j = _.keys(group).length - 1; j >= 0; j--) {
                    out[group] = _.groupBy(_.filter(_.flatten(_.map(groups[group], 'property_pests_filtered')), function(pp) {
                        return that.pests[pp.pest_id].group_id == gid
                    }), 'pest_id')
                }
            }
            return out
        },
        inspectionDevicePests(group, pest, inspection, device) {
            var that = this;
            return _(this.targetpests[group][pest]).filter({ device_id: device.id, inspection_id: inspection.id }).map('property_pests_filtered').flatten().uniqBy('id').filter({ pest_id: parseInt(pest) }).map(
                function(pp) {
                    return " " + that.pests[pp.pest_id].name + " (" + pp.quantity + ")"
                }
            ).value();
        },
        inspectionDevicePestsSum(group, pest, inspection, device) {
            var quantities = _(this.targetpests[group][pest]).filter({ device_id: device.id, inspection_id: inspection.id }).map('property_pests_filtered').flatten().uniqBy('id').filter({ pest_id: parseInt(pest) }).map('quantity')
            if (quantities.value().length == 0) return "-";
            return quantities.sum();
        },
        hasQuantity(group, pest, subitems) {
            var ids = _.map(_.keys(subitems), no => { return parseInt(no) });
            if (_.isArray(subitems)) {
                ids = _.map(subitems, 'id');
            }
            var filtered_conforms = _.filter(this.targetpests[group][pest], pp => {
                return _.filter(pp.property_pests_filtered, { pest_id: parseInt(pest) }).length > 0;
            });
            return _.intersection(
                _.map(_.keys(_.groupBy(filtered_conforms, 'device_id')), parseInt), ids
            ).length > 0
        },
        groupHasQuantity(group, pest, items) {
            return this.hasQuantity(group, pest, _.flatten(_.values(items)))
        },
        devicePestsSum(group, pest, device) {
            var quantities = _(this.targetpests[group][pest]).filter({ device_id: device.id }).map('property_pests_filtered').flatten().uniqBy('id').filter({ pest_id: parseInt(pest) }).map('quantity');
            if (quantities.value().length == 0) return "-";
            return quantities.sum();
        },
        inspectionPestsSum(group, pest, inspection, devices) {
            var quantities = _(this.targetpests[group][pest]).filter({ inspection_id: inspection.id }).filter(q => {
                return _.find(devices, { id: q.device_id }) != undefined;
            }).map('property_pests_filtered').flatten().uniqBy('id').filter({ pest_id: parseInt(pest) }).map('quantity');
            if (quantities.value().length == 0) return "-";
            return quantities.sum();
        },
        criteriaForDeviceZone: function(zid, dc) {
            var out = []
            for (var i = 0; i < this.inspections.length; i++) {
                var inspection = this.inspections[i];
                var zone = _.find(inspection.zones, { id: parseInt(zid) })
                if (_.isUndefined(zone) == false) {
                    var dcc = _.find(zone.criteria_table, { device_category_id: parseInt(dc) })
                    if (_.isUndefined(dcc) == false) {
                        out.push([inspection.date, dcc]);
                    }
                }
            }
            return _.uniqBy(out, function(pair) {
                return pair[1].updated_at;
            });
        }
    },
    computed: {
        listItems() {
            var that = this;
            var output = [];
            if (this.groupby == 'dev_category') {
                var nongroupped = _.groupBy(_.filter(_.orderBy(this.devices, 'dev_num'), function(item) {
                    return (item.timestamp / 1000) < moment(that.to).unix();
                }), 'dev_category');
            } else if (this.groupby == 'zone_id') {
                var nongroupped = _.groupBy(_.filter(_.orderBy(this.devices, 'dev_num'), function(item) {
                    return (item.timestamp / 1000) < moment(that.to).unix();
                }), 'zone_id');
            }
                var zones_groups_devices = {};
                for (var i = _.keys(nongroupped).length - 1; i >= 0; i--) {
                    var key = _.keys(nongroupped)[i];
                    var devcats = _.groupBy(nongroupped[key], 'dev_category');
                    zones_groups_devices[_.keys(nongroupped)[i]] = {};
                    for (var j = _.keys(devcats).length - 1; j >= 0; j--) {
                        zones_groups_devices[_.keys(nongroupped)[i]][_.keys(devcats)[j]] = _.keyBy(devcats[_.keys(devcats)[j]], 'id')
                    }
                }
                for (const [key, value] of Object.entries(zones_groups_devices)) {
                    for (const [subkey, subvalues] of Object.entries(value)) {
                        output.push({ group: key, subgroup: subkey, items: subvalues});
                    }
                }
                return _.orderBy(output, (row)=>{
                    if(that.orderby == "dev_category"){
                        return this.devcats[row.subgroup].name;
                    }else{
                        if(this.place.zones_groups == undefined) return "";
                        if(_.isUndefined(this.place.zones_groups[row.group])){
                            return "";
                        }else{
                            return this.place.zones_groups[row.group].name;
                        }
                    }
                });
        },
        listZones: function(){
            return _.uniq(_.map(this.listItems, 'group'));
        },
        listAllGroups: function(){
            return _.map(this.listItems, function(listItem){return ""+listItem.group+":"+listItem.subgroup });
        },
        targetpests: function() {
            var targets = _.filter(_.flatten(_.values(this.properties)), { 'property_method': "pests_quantity" });
            var groups = {};
            for (var i = targets.length - 1; i >= 0; i--) {
                var prop = targets[i];
                var device = this.devices[prop.device_id];
                var insp = _.keyBy(this.inspections, 'id')[prop.inspection_id];
                var zone = _.keyBy(insp.zones, 'id')[device.zone_id];
                if(zone != undefined){
                var criterium = _.keyBy(zone.criteria_table, "device_category_id")[device.dev_category];
                if (criterium != undefined) {
                    for (var j = prop.property_pests.length - 1; j >= 0; j--) {
                        var pp = prop.property_pests[j];
                        var pest = this.pests[pp.pest_id];
                        prop.property_pests_filtered = [];
                        console.log(_.keyBy(criterium.pests_thresolds, 'pest_id'), pp, pest, this.pestsgroups, _.keyBy(criterium.pests_thresolds, 'group_id'));
                        if(pest != undefined){
                            console.log(this.pestsgroups[pest.group_id], _.keyBy(criterium.pests_thresolds, 'group_id')[pest.group_id]  )
                             if (_.isUndefined(groups[pest.group_id])) {
                                    groups[pest.group_id] = {};
                             }
                              if (_.isUndefined(groups[pest.group_id][pest.id])) {
                                    groups[pest.group_id][pest.id] = [];
                                }
                            if (_.isUndefined(_.keyBy(criterium.pests_thresolds, 'pest_id')[pp.pest_id]) == false) {
                                prop.property_pests_filtered.push(pp);
                                if (_.isUndefined(_.find(groups[pest.group_id][pest.id], { chkey: prop.ckey }))) groups[pest.group_id][pest.id].push(prop);

                            }
                                                      if (_.isUndefined(_.keyBy(criterium.pests_thresolds, 'group_id')[pest.group_id]) == false) {
                                prop.property_pests_filtered.push(pp);
                                if (_.isUndefined(_.find(groups[pest.group_id][pest.id], { chkey: prop.ckey }))) groups[pest.group_id][pest.id].push(prop);

                            }
                        }

                    }
                }}
            }
            return groups;
        },
        lastInspection: function() {
            var inps = _.last(_.orderBy(this.inspections, 'date'));
            if (_.isUndefined(inps) == false)
                return inps.date;
            return "-"
        },

    },
    mixins: [Vue2Filters.mixin],
}
</script>
<style scoped>
.maincontainer {
    text-align: left;
}

p {
    font-size: 2em;
    text-align: center;
}

thead th {
    font-weight: 300;
}

thead .input-field {
    margin-top: unset;
    margin-bottom: unset;
}

.section {
    border: 2px solid black;
    margin-top: 25px;
    margin-bottom: 25px;
}

.section h4 {
    padding-top: 0.25rem;
    padding-left: 0.25rem;
    padding-bottom: 0.25rem;
}

.grey {
    border: none;
}

/deep/ h5 {
    padding-top: 15px;
    padding-bottom: 15px;
}

td:not(:last-child),
th:not(:last-child) {
    border-right: 1px solid rgba(0, 0, 0, 0.12);
    padding: 5px;
}

.rotate {
    vertical-align: bottom;
}

.rotate div {
    -webkit-writing-mode: vertical-rl;
    -ms-writing-mode: tb-rl;
    writing-mode: vertical-rl;
    transform: rotate(-180deg);
    width: 100%;
    display: grid;
    grid-auto-columns: max-content;
    align-content: baseline;
    justify-items: start;
    line-height: 1 !important;
}
.adder {
    border-radius: 8px;
}
.filteractive{
    padding-left: 2em;
}
.filteractive::before{
    content: "[x]";
}
.filterinactive{
    padding-left: 2em;
}
.filterinactive::before{
    content: "[ ]";
}
</style>
